import { styled } from '@linaria/react';

export const StyledChooseSteps = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: var(--gap-x7);
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: var(--gap-x7);
`;
